import React, { useState } from 'react';
import Hero from '../../components/Hero';
import HomeIcon from '@mui/icons-material/Home';
import { api } from "./api";
import { Box, Snackbar, Alert } from '@mui/material';
import AddSupplyForm from '../../components/addSuplyForm';

const AddSupply = () => {
  const [successOpen, setSuccessOpen] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");


const handleAddSupply = async ({ cliCod, sumNro, docTipo, docNumero }) => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const usuarioId = user.Id;

  try {
    await api.suministro.addSupply({
      usuarioId,
      cliCod: parseInt(cliCod, 10),
      sumNro: parseInt(sumNro, 10),
      docTipo,
      docNumero
    });
    setSuccessOpen(true);
  } catch (e) {
  setErrorMsg(e.message || "Ocurrió un error en el servidor. Intentá nuevamente.");
  setErrorOpen(true);
}

};


  return (
    <>
      <Hero>
        <Box
          sx={{
            p: { xs: 2, sm: 3 },
            borderRadius: 3,
            boxShadow: 4,
            textAlign: "center",
            bgcolor: "#64AE37",
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 1
          }}
        >
          <HomeIcon sx={{ fontSize: { xs: 35 } }} />
          <Box component="h1" sx={{ fontWeight: 'bold', m: 0 }}>
            Suministros asociados
          </Box>
        </Box>
      </Hero>

      <AddSupplyForm onSubmit={handleAddSupply} />

      {/* SUCCESS */}
      <Snackbar
        open={successOpen}
        autoHideDuration={3000}
        onClose={() => setSuccessOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={() => setSuccessOpen(false)} severity="success" sx={{ width: "100%" }}>
          Suministro agregado correctamente
        </Alert>
      </Snackbar>

      {/* ERROR */}
      <Snackbar
        open={errorOpen}
        autoHideDuration={5000}
        onClose={() => setErrorOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={() => setErrorOpen(false)} severity="error" sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddSupply;
